/**
* @desc: 对公转账弹窗提醒
* @author: zengtiansheng
* @update: 2018/3/17
*/
<style lang="less" scoped>
.dialog-title {
  margin-left: 20px;
  color: #9c9c9c;
  font-size: 12px;
}
.dialog-content {
  margin-left: 20px;
  .part-img {
    width: 60px;
    height: 60px;
    margin-right: 20px;
    border-radius: 30px;
  }
  .detail {
    color: #3c3c3c;
    font-size: 12px;
    p {
      margin-bottom: 4px;
    }
  }
}
</style>
<template>
  <el-dialog :visible.sync="dialogVisible" width="520px">
    <div slot="title" class="dialog-title">
      <p>若您需要对公账户进行充值，转账成功后请联系我们商务经理</p>
      <p style="color:#F85359;">对公转账请务必备注付款公司名称</p>
    </div>
    <div class="dialog-content f-js-as">
      <img class="part-img" src="https://qiniu-image.qtshe.com/logo_bak.png-100" alt="part-img" />
      <div class="detail">
        <p>
          <span style="margin-right: 40px">商务经理：陈欣</span>
          <span>电话：18815294089</span>
        </p>
        <p>收款公司：杭州青团宝网络科技有限责任公司</p>
        <p>账户名：杭州青团宝网络科技有限责任公司</p>
        <p>对公充值账户：8888888499748000</p>
        <p>开户行：民营银行</p>
        <p>支行名称：浙江网商银行股份有限公司</p>
        <p>地区：浙江省，杭州市</p>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible=false">我知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/transferAccRemind.vue